export { DispensaryCollectionPage } from './collection';
